import React, { ReactNode } from 'react';
import { VobsColorTheme, VOBS_COLORS } from './vobs.constants';
import './DownloadCard.scss';

interface DownloadCardProps {
  title: string;
  subtitle: string;
  description: string;
  color: VobsColorTheme;
  icon: string;
  granularity: string;
  format: string;
  selector: ReactNode;
  fileName: string | null;
  onDownload: () => void;
  isLoading: boolean;
  disabled: boolean;
}

export default function DownloadCard({
  title,
  subtitle,
  description,
  color,
  icon,
  granularity,
  format: fileFormat,
  selector,
  fileName,
  onDownload,
  isLoading,
  disabled,
}: DownloadCardProps) {
  const { accent } = VOBS_COLORS[color];

  return (
    <div className="vobs-card">
      <div className="vobs-card-header">
        <div>
          <p className="vobs-card-title">{title}</p>
          <p className="vobs-card-subtitle">{subtitle}</p>
        </div>
        <div className="vobs-card-icon" style={{ backgroundColor: accent }}>
          {icon}
        </div>
      </div>

      <p className="vobs-card-description">{description}</p>

      <div className="vobs-card-selector">{selector}</div>

      <button
        type="button"
        className="vobs-card-download-btn"
        style={{ backgroundColor: disabled ? undefined : accent }}
        onClick={onDownload}
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <>
            <span className="spinner-border spinner-border-sm" role="status" />
            Baixando...
          </>
        ) : (
          <>
            <span>&#x2913;</span>
            {`Baixar ${title}`}
          </>
        )}
      </button>

      {fileName && (
        <div className="vobs-card-filename">{fileName}</div>
      )}

      <div className="vobs-card-meta">
        <span className="vobs-card-meta-dot" style={{ backgroundColor: accent }} />
        {`Granularidade: ${granularity} | Formato: ${fileFormat}`}
      </div>
    </div>
  );
}
